import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import ReactMarkdown from 'react-markdown';
import { connect } from 'react-redux';
import { _ } from '/@/locale';
import { getSessionLanguage } from '/@/store/session/selectors';
import { getGroups } from '/@/utils';
import styles from './styles.module.css';

@connect((state) => {
    return {
        language: getSessionLanguage(state),
    };
})
@autobind
export default class Notes extends Component {
    static propTypes = {
        notes: PropTypes.arrayOf(PropTypes.string),
        columns: PropTypes.number,
    };

    static defaultProps = {
        columns: 1,
    };

    render() {
        const groups = getGroups(this.props.notes, this.props.columns);
        const width = `${100 / (groups.length || 1)}%`;

        return (
            <div className={styles.root}>
                {groups.map((notes, index) => (
                    <ul key={`group-${index}`} style={{ width }} className={styles.column}>
                        {notes.map((note, index) => (
                            <li key={index}>
                                <i className='material-icons'>done</i>
                                <ReactMarkdown className={styles.text}>{_(note)}</ReactMarkdown>
                            </li>
                        ))}
                    </ul>
                ))}
            </div>
        );
    }
}
